import client from '@/query/client';
import queries from '@/query/queries';

class Country {
  get validate_last_6_months() {
    return this.select({
      southkorea: false,
      default: true,
    });
  }

  get show_applicant_details() {
    return this.select({
      southkorea: true,
      default: false,
    });
  }

  get show_trip_sponsor() {
    return this.select({
      southkorea: false,
      default: true,
    });
  }

  get validate_embassy_itr() {
    return this.select({
      southkorea: true,
      default: false,
    });
  }

  get show_strong_application_message() {
    return this.select({
      southkorea: false,
      tenant: false,
      default: true,
    });
  }

  get flag() {
    return this.select({
      serbia: () => import('@/assets/images/flags/serbiaFlag.png'),
      czech: () => import('@/assets/images/flags/czechFlag.png'),
      skorea: () => import('@/assets/images/flags/southkoreaFlag.png'),
      southkorea: () => import('@/assets/images/flags/southkoreaFlag.png'),
      georgia: () => import('@/assets/images/flags/georgiaFlag.png'),
      thailand: () => import('@/assets/images/flags/thailandFlag.png'),
      greece: () => import('@/assets/images/flags/greeceFlag.png'),
      default: () => import('@/assets/images/flags/georgiaFlag.png'),
    });
  }

  get country_visa_type() {
    return this.select({
      serbia: 'Serbia Visa',
      czech: 'Czech Republic Visa',
      skorea: 'South Korea Visa',
      southkorea: 'South Korea',
      georgia: 'Georgia eVisa',
      thailand: 'Thailand eVisa',
      greece: 'Greece eVisa',
      default: 'Georgia eVisa',
    });
  }

  get map() {
    return this.select({
      skorea: () => import('@/assets/svg/maps/SouthKoreaMap.tsx'),
      southkorea: () => import('@/assets/svg/maps/SouthKoreaMap.tsx'),
      georgia: () => import('@/assets/svg/maps/GeorgiaMap.tsx'),
      thailand: () => import('@/assets/svg/maps/ThailandMap.tsx'),
      greece: () => import('@/assets/svg/maps/GreeceMap.tsx'),
      default: () => import('@/assets/svg/maps/GeorgiaMap.tsx'),
    });
  }

  get application_validity() {
    return this.select({
      southkorea: '7 Days',
      georgia: '24 hours',
      thailand: '24 hours',
      greece: '24 hours',
      default: '24 hours',
    });
  }

  select<T>(
    config:
      | ({[country in CountryType]?: T} & {default: T})
      | {[country in CountryType]: T},
  ): T {
    if ('default' in config) {
      return config[this.meta.subdomain] ?? config.default;
    }
    return config[this.meta.subdomain];
  }

  get is_south_korea() {
    return this.meta.subdomain === 'southkorea';
  }

  get is_skorea() {
    return this.meta.subdomain === 'skorea';
  }

  get is_georgia() {
    return this.meta.subdomain === 'georgia';
  }

  get is_serbia() {
    return this.meta.subdomain === 'serbia';
  }

  get meta() {
    return client.getQueryData<MetaData>(queries.meta.queryKey)!;
  }
}

export default new Country();
